module.exports = __webpack_public_path__ + "img/particle_motion_00071.92df4f16.png";